import { yodaMessageCostants } from "../constants/yodaMessage.costants";

const yodaMessagesReducer = (
  state = {
    messages: [],
  },
  action,
) => {
  switch (action.type) {
    case yodaMessageCostants.GET_MESSAGE_REQUEST:
      return {
        ...state,
      };

    case yodaMessageCostants.GET_MESSAGE_SUCCESS:
      return {
        ...state,
        messages: action.payload.messages,
      };

    case yodaMessageCostants.GET_MESSAGE_REQUEST_FAILURE:
      return {
        ...state,
      };

    case yodaMessageCostants.CLEAR_MESSAGE_REQUEST:
      return {
        ...state,
      };

    case yodaMessageCostants.CLEAR_MESSAGE_REQUEST_FAILURE:
      return {
        ...state,
      };

    case yodaMessageCostants.CLEAR_MESSAGE_REQUEST_SUCCESS:
      return {
        ...state,
        messages: [],
      };

    default:
      return state;
  }
};

export default yodaMessagesReducer;
